import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedAccident } from "../../../../actions/accidentDashboard";
import {
  cleanAccidentsWithFilters,
  getAccidentsWithFilters,
  reOpenAccident,
} from "../../../../actions/accidents";
import snackbarUtils from "../../../../utils/snackbarUtils";
import ConfirmDialog from "../../../commons/dialog/confirmDialog";
import Search from "../../../commons/search/search";
import AccidentTable from "../../../commons/table/accidentTable";
import { StyledSearchContainer } from "../../../styled/accident";
import AccidentDashboardContainer from "../accidentDashboard/accidentDashboardContainer";
import EditAccidentContainer from "../edit/editAccidentContainer";

const SearchContainer = () => {
  const [displayAccidents, setDisplayAccidents] = useState("block");

  const dispatch = useDispatch();

  const accidents = useSelector((state) => state.accidents);
  const art = useSelector((state) => state.art.artsAdhered);

  const [accidentToEdit, setAccidentToEdit] = useState(null);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [accidentToReopen, setAccidentToReOpen] = useState(null);
  const [lastSearchFilters, setLastSearchFilters] = useState("");

  useEffect(() => {
    dispatch(cleanAccidentsWithFilters());
  }, []);

  const handleSearch = (params) => {
    dispatch(getAccidentsWithFilters(params));
    setLastSearchFilters(params);
  };

  const handleOpenConfirmDialog = (accident) => {
    setOpenConfirmDialog(true);
    setAccidentToReOpen(accident);
  };

  const handleAccidentDetail = (accident) => {
    dispatch(setSelectedAccident(accident));
    setDisplayAccidents("none");
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false);
  };

  const confirmReOpenAccident = () => {
    dispatch(reOpenAccident(accidentToReopen))
      .then(() => {
        handleCloseConfirmDialog();
        handleSearch(lastSearchFilters);
        snackbarUtils.success("Siniestro reabierto correctamente");
      })
      .catch((err) => err && handleCloseConfirmDialog());
  };

  const handleResetSearch = () => {
    setLastSearchFilters("");
    dispatch(cleanAccidentsWithFilters());
  };

  return (
    <StyledSearchContainer.Container>
      {displayAccidents === "none" && (
        <AccidentDashboardContainer setDisplayAccidents={setDisplayAccidents} />
      )}
      {displayAccidents != "none" && (
        <div>
          <StyledSearchContainer.Title variant="h6">
            Buscar Siniestro
          </StyledSearchContainer.Title>
          <Search handleSearch={handleSearch} art={art} handleReset={handleResetSearch} />
        </div>
      )}
      <AccidentTable
        data={accidents.listFilter}
        showArtColumn
        loading={accidents.isFetchingFilter}
        error={accidents.didInvalidateFilter}
        noRefresh
        handleAccidentDetail={handleAccidentDetail}
        displayAccidents={displayAccidents}
        handleEdit={(accident) => setAccidentToEdit(accident)}
        handleReOpenAccident={(accident) => handleOpenConfirmDialog(accident)}
        openInSearch={true}
      />
      <EditAccidentContainer
        accident={accidentToEdit}
        handleClose={() => setAccidentToEdit(null)}
      />
      <ConfirmDialog
        open={openConfirmDialog}
        handleClose={handleCloseConfirmDialog}
        handleConfirm={confirmReOpenAccident}
        title={"¿Está seguro que desea reabrir este Siniestro?"}
        text="Al hacerlo, el mismo será accesible desde Siniestros > En Curso."
        warningText="Advertencia: Si el Siniestro no está abierto para la ART, esta acción no se ejecutará."
        loading={accidents.reOpen.isFetching}
      />
    </StyledSearchContainer.Container>
  );
};

export default SearchContainer;
